import { render, staticRenderFns } from "./EditContentFeaturedImageModal.vue?vue&type=template&id=3739ec25&lang=pug&"
import script from "./EditContentFeaturedImageModal.vue?vue&type=script&lang=js&"
export * from "./EditContentFeaturedImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports